import React from 'react';
import Big from 'big.js';

import { useSaveListingManagementStrategyMutation } from 'generated/graphql';
import * as types from './types';



export function useSaveListingManagementStrategy(listingManagementStrategyId: string) {
  const [fnMutate, tuple] = useSaveListingManagementStrategyMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      const price = new Big(formState.priceDollars).toFixed(2);
      await fnMutate({
        variables: {
          input: {
            id: listingManagementStrategyId,
            priceDollars: new Big(price).toFixed(2),
            overwriteRelatedItemPrices: formState.overwriteExistingPrices
          }
        }
      });
    },
    [
      fnMutate,
      listingManagementStrategyId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
